/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  RiskScoreResponse
} from '.././model';

import { customCatchBackendFetcher } from '../../../client/customFetcher';




/**
 * Get user's risk scores with population benchmarks

Returns:
    RiskScoreResponse with lifetime risk, benchmark status, and methodology info
 * @summary Get Risk Scores
 */
export const getRiskScoresV1RiskScoresGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<RiskScoreResponse>(
      {url: `/v1/risk-scores`, method: 'GET', signal
    },
      );
    }
  

export const getGetRiskScoresV1RiskScoresGetQueryKey = () => {
    return [`/v1/risk-scores`] as const;
    }

    
export const getGetRiskScoresV1RiskScoresGetQueryOptions = <TData = Awaited<ReturnType<typeof getRiskScoresV1RiskScoresGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskScoresV1RiskScoresGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRiskScoresV1RiskScoresGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRiskScoresV1RiskScoresGet>>> = ({ signal }) => getRiskScoresV1RiskScoresGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRiskScoresV1RiskScoresGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetRiskScoresV1RiskScoresGetQueryResult = NonNullable<Awaited<ReturnType<typeof getRiskScoresV1RiskScoresGet>>>
export type GetRiskScoresV1RiskScoresGetQueryError = unknown


export function useGetRiskScoresV1RiskScoresGet<TData = Awaited<ReturnType<typeof getRiskScoresV1RiskScoresGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskScoresV1RiskScoresGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRiskScoresV1RiskScoresGet>>,
          TError,
          Awaited<ReturnType<typeof getRiskScoresV1RiskScoresGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRiskScoresV1RiskScoresGet<TData = Awaited<ReturnType<typeof getRiskScoresV1RiskScoresGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskScoresV1RiskScoresGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRiskScoresV1RiskScoresGet>>,
          TError,
          Awaited<ReturnType<typeof getRiskScoresV1RiskScoresGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRiskScoresV1RiskScoresGet<TData = Awaited<ReturnType<typeof getRiskScoresV1RiskScoresGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskScoresV1RiskScoresGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Risk Scores
 */

export function useGetRiskScoresV1RiskScoresGet<TData = Awaited<ReturnType<typeof getRiskScoresV1RiskScoresGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskScoresV1RiskScoresGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetRiskScoresV1RiskScoresGetQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



